import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TipoStazione } from '@app/shared/models/stazione';
import { StazioneService, IRicercaStazioneParams } from '@app/shared/services/stazione.service';

@Component({
  selector: 'ser-stazione-select',
  templateUrl: './stazione-select.component.html',
  styleUrl: './stazione-select.component.scss'
})
export class StazioneSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() readonly: boolean;
  @Input() label: string = 'stazioni.title.dettaglio';
  @Input() type: TipoStazione = TipoStazione.ALL;

  stazioni: IS1InputSelectItem[];

  constructor(private stazioneService: StazioneService) { }

  ngOnInit(): void { 
    this.loadItems();
  }

  loadItems() {

    const params: IRicercaStazioneParams = {
      page: 1,
      pageSize: 999,
      sortBy: "descrizione",
      inGestione: this.type == TipoStazione.USCITA ? true : null
    }
  
    this.stazioneService.ricerca(params).subscribe(stazioniPaginate => {
  
      this.stazioni = stazioniPaginate?.elements?.map(stazione => { 
        return { code: stazione.id, label: stazione.descrizione?.trim() }  
      }) ?? [];
  
      if (this.stazioni?.length == 1) {
        this.control?.patchValue(this.stazioni[0].code);
      }
  
    })

  }

}
